import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Col, Modal, Popover, Row, Tag, Tooltip } from "antd";
import React from "react";

function InfoUserModal(props) {
  function getPositions() {
    let output = [];
    props.user?.positions?.forEach((position) => {
      output.push(
        <>
          <div className="flex items-center" key={position?.id}>
            <Popover
              placement="top"
              content={
                <div className="text-xs">{position.unit?.level?.name}</div>
              }
              trigger="hover"
            >
              <div
                className="w-2 h-2 mr-1 rounded-full"
                style={{ backgroundColor: position.unit?.level?.color }}
              />
            </Popover>
            <div>{position.unit?.name}</div>
            <Popover
              placement="top"
              content={
                <div className="text-xs">
                  {position.unit?.name}
                  {position.unit?.headUnit &&
                    " < " + position.unit?.headUnit?.name}
                  {position.unit?.headUnit?.headUnit &&
                    " < " + position.unit?.headUnit?.headUnit?.name}
                </div>
              }
              trigger="hover"
            >
              <div className="text-gray-500 text-xs ml-1">
                <InfoCircleOutlined />
              </div>
            </Popover>
            {", " + position.designation?.name}
            <Tooltip title={"Remove position"}>
              <div
                onClick={() => {
                  props.handlePositionDelete(position.id);
                }}
                className="text-red-500 hover:text-red-600 cursor-pointer inline ml-1"
              >
                <DeleteOutlined />
              </div>
            </Tooltip>
          </div>
        </>
      );
    });
    return output;
  }

  return (
    <Modal
      title={props.title}
      visible={props.visible}
      onCancel={props.handleCancel}
      footer={null}
      destroyOnClose={true}
    >
      <Row>
        <Col span={12} className="mb-6">
          <div className="text-xs">Name</div>
          <div>{props.user?.firstName || "-"}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Username</div>
          <div>{props.user?.username || "-"}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Email</div>
          <div>{props.user?.email || "-"}</div>
        </Col>
        <Col span={12}>
          <div className="text-xs">Contact no</div>
          <div>{props.user?.phone || "-"}</div>
        </Col>
        <Col span={12}>
          <div className="text-xs">Address</div>
          <div>{props.user?.address || "-"}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Status</div>
          <Tag color={"green"}>{props.user?.status?.toUpperCase()}</Tag>
        </Col>
        <Col span={24} className="mb-6">
          <div className="text-xs">Positions</div>
          {props.user?.positions?.length ? getPositions() : "-"}
        </Col>
      </Row>
    </Modal>
  );
}

export default InfoUserModal;
